<template>
  <div class="card mb-25 border-0 rounded-0 bg-white">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-md-30 d-sm-flex align-items-center justify-content-between"
      >
        <h6 class="card-title fw-bold mb-0">Les derniers contrats</h6>
      </div>
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Demandeur
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Code
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Loyer
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Statut
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(dem, index) in demandes" :key="index">
              <th class="shadow-none lh-1 fw-bold ps-0">
                  {{ dem.nomMarchand }}
              </th>
              <td class="shadow-none lh-1 fw-semibold text-black-emphasis">
                {{ dem.codePlace }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ dem.loyer }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ format_date(dem.createdAt) }}
              </td>
              <td class="shadow-none lh-1 fw-medium">
                <span v-if="dem.status=='En attente'" class="badge text-outline-danger">{{ dem.status }}</span>
                <span  v-else-if="dem.status=='Validée'" class="badge text-outline-success">{{ dem.status }}</span>
                <span  v-else-if="dem.status=='Acceptée'" class="badge text-outline-warning">{{ dem.status }}</span>
                <span v-else class="text-outline-info">{{ dem.status }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent,ref,onMounted } from "vue";
import stockReport from "./stockReport.json";
import axios from 'axios';
import {separateur, format_date} from '../../../../utils/utils'

export default defineComponent({
  name: "StockReport",
  setup: () => {
    const demandes = ref([]);
    const fetchFactures =async () => {
      try {
        const response = await axios.get(`/statistiques/contrat/dix`);
        demandes.value = response.data.data;
        return demandes.value;
      } catch (error) {
        //
      }
    }
    onMounted(async () => {
     await fetchFactures();
    });
    return {
      demandes,
      format_date,fetchFactures,
      stocks: stockReport,
    };
  },
});
</script>